/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Goto_JobInputs */

const en_admin_statistics_goto_job = /** @type {(inputs: Admin_Statistics_Goto_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to job posting`)
};

const de_admin_statistics_goto_job = /** @type {(inputs: Admin_Statistics_Goto_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Stellenausschreibung`)
};

/**
* | output |
* | --- |
* | "Go to job posting" |
*
* @param {Admin_Statistics_Goto_JobInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_goto_job = /** @type {((inputs?: Admin_Statistics_Goto_JobInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Goto_JobInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_goto_job(inputs)
	return en_admin_statistics_goto_job(inputs)
});